import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ordersApi } from '../../services/api/orders.api';
import { FaCheckCircle } from 'react-icons/fa';

// مكون أيقونة الريال السعودي
const RiyalIcon = () => (
    <span style={{ fontFamily: 'saudi_riyal', fontSize: '1.2em' }}>&#xE900;</span>
);

const OrderConfirmation = () => {
    const { orderId } = useParams();
    const navigate = useNavigate();
    const orderData = useSelector(state => state.checkout.orderData);
    const [order, setOrder] = useState(orderData);
    const [loading, setLoading] = useState(!orderData);

    useEffect(() => {
        const fetchOrder = async () => {
            try {
                const response = await ordersApi.getOrder(orderId);
                setOrder(response);
                
                // طباعة البيانات المستلمة للتتبع
                console.log('بيانات الطلب المستلمة:', JSON.stringify(response, null, 2));
                
                // تحديث sessionStorage فقط إذا كانت حالة الطلب مكتملة (completed)
                console.log('حالة الطلب:', response.status);
                console.log('بيانات الطلب كاملة:', JSON.stringify(response, null, 2));
                
                // الحالات المقبولة لتحديث المشتريات
                const validStatuses = ['completed', 'accepted', 'paid'];
                const isValidStatus = validStatuses.includes(response.status);
                
                console.log('هل الحالة صالحة للتحديث؟', isValidStatus);
                
                if (response && response.items && isValidStatus) {
                    try {
                        // جلب الدورات الحالية من sessionStorage
                        const storedCourses = sessionStorage.getItem('dose_user_courses');
                        const currentCourses = storedCourses ? JSON.parse(storedCourses) : [];
                        console.log('الدورات الحالية في sessionStorage:', currentCourses);
                        console.log('نوع البيانات المخزنة:', typeof storedCourses);
                        
                        // استخراج معرفات الدورات الجديدة من الطلب
                        const newCourseIds = response.items
                            .filter(item => item.course_id || item.course?.id)
                            .map(item => item.course_id || item.course.id);
                        
                        if (newCourseIds.length > 0) {
                            const updatedCourses = [...new Set([...currentCourses, ...newCourseIds])];
                            sessionStorage.setItem('dose_user_courses', JSON.stringify(updatedCourses));
                            window.dispatchEvent(new Event('storage'));
                        }
                    } catch (error) {
                        console.error('خطأ في تحديث المشتريات:', error);
                    }
                }
            } catch (error) {
                console.error('Error fetching order:', error);
            } finally {
                setLoading(false);
            }
        };

        if (orderId) {
            fetchOrder();
        }
    }, [orderId]);

    if (loading) {
        return (
            <div className="bg-gray-50 dark:bg-gray-900 py-6 flex flex-col justify-center">
                <div className="text-gray-500 dark:text-gray-400">جاري التحميل...</div>
            </div>
        );
    }

    if (!order) {
        return (
            <div className="bg-gray-50 dark:bg-gray-900 py-6 flex flex-col justify-center">
                <div className="text-gray-500 dark:text-gray-400">لم يتم العثور على الطلب</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-6 flex flex-col justify-center">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 my-auto">
                {/* الفاتورة المقصوصة مع تأثير ظل */}
                <div className="relative bg-white dark:bg-gray-800 shadow-2xl rounded-lg overflow-hidden" style={{ boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}>
                    {/* الجزء المقصوص من الأعلى - شكل مثلثات */}
                    <div className="w-full h-6 bg-gray-100 dark:bg-gray-900 overflow-hidden">
                        <div className="flex w-full justify-between">
                            {[...Array(40)].map((_, i) => (
                                <div key={i} className="w-3 h-6 bg-white dark:bg-gray-800" style={{ clipPath: 'polygon(50% 0%, 0 100%, 100% 100%)', margin: '0 -1px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}></div>
                            ))}
                        </div>
                    </div>
                    
                    <div className="px-4 py-5 sm:p-6">
                        <div className="text-center">
                            <FaCheckCircle className="mx-auto h-16 w-16 text-green-500" />
                            <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-white">
                                تم استلام طلبك!
                            </h3>
                            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                                {order.status === 'completed' || order.status === 'accepted'
                                    ? 'تم تأكيد طلبك بنجاح! يمكنك الآن الوصول للدورات المشتراة.'
                                    : order.payment_method === 'bank_transfer'
                                    ? 'تم استلام طلبك بنجاح. سيتم تفعيل الاشتراك بعد مراجعة التحويل البنكي.'
                                    : 'شكراً لك على الطلب. سيتم مراجعة طلبك وتأكيده قريباً.'}
                            </p>
                        </div>

                        <div className="mt-6 border-t border-dashed border-gray-200 dark:border-gray-700 pt-6">
                            <div className="space-y-4">
                                <div>
                                    <h4 className="text-base font-medium text-gray-900 dark:text-white">
                                        تفاصيل الطلب
                                    </h4>
                                    <dl className="mt-2 space-y-2">
                                        <div>
                                            <dt className="inline text-sm text-gray-500 dark:text-gray-400">رقم الطلب: </dt>
                                            <dd className="inline text-sm text-gray-900 dark:text-white">{order.id}</dd>
                                        </div>
                                        <div>
                                            <dt className="inline text-sm text-gray-500 dark:text-gray-400">المبلغ الإجمالي: </dt>
                                            <dd className="inline text-sm text-gray-900 dark:text-white">{parseInt(order.final_total)} <RiyalIcon /></dd>
                                        </div>
                                        <div>
                                            <dt className="inline text-sm text-gray-500 dark:text-gray-400">طريقة الدفع: </dt>
                                            <dd className="inline text-sm text-gray-900 dark:text-white">
                                                {order.payment_method === 'bank-transfer' ? 'تحويل بنكي' : 
                                                 order.payment_method === 'tamara' ? 'تمارا' : 
                                                 order.payment_method === 'installment' ? 'تقسيط' : 'دفع إلكتروني'}
                                            </dd>
                                        </div>
                                        {order.installment && (
                                            <>
                                                <div className="border-t border-dashed border-gray-200 dark:border-gray-700 pt-2 mt-2">
                                                    <p className="text-sm font-medium text-gray-900 dark:text-white mb-2">تفاصيل التقسيط</p>
                                                </div>
                                                <div>
                                                    <dt className="inline text-sm text-gray-500 dark:text-gray-400">عدد الدفعات: </dt>
                                                    <dd className="inline text-sm text-gray-900 dark:text-white">{order.installment.installment_count}</dd>
                                                </div>
                                                <div>
                                                    <dt className="inline text-sm text-gray-500 dark:text-gray-400">الدفعة الأولى: </dt>
                                                    <dd className="inline text-sm text-gray-900 dark:text-white">{order.installment.paid_amount} <RiyalIcon /></dd>
                                                </div>
                                                <div>
                                                    <dt className="inline text-sm text-gray-500 dark:text-gray-400">المبلغ المتبقي: </dt>
                                                    <dd className="inline text-sm text-gray-900 dark:text-white">{order.installment.remaining_amount} <RiyalIcon /></dd>
                                                </div>
                                            </>
                                        )}
                                    </dl>
                                </div>

                                <div className="border-t border-dashed border-gray-200 dark:border-gray-700 pt-4">
                                    <h4 className="text-base font-medium text-gray-900 dark:text-white">
                                        المنتجات
                                    </h4>
                                    <div className="mt-2">
                                        <div className="flex justify-between text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">
                                            <span>المنتج</span>
                                            <span>السعر</span>
                                        </div>
                                        {order.items?.map((item) => (
                                            <div key={item.id} className="flex justify-between py-2 border-b border-gray-100 dark:border-gray-800">
                                                <span className="text-sm text-gray-800 dark:text-gray-200">
                                                    {item.book?.title || item.course?.title}
                                                </span>
                                                <span className="text-lg font-bold">{item.price} <RiyalIcon /></span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="border-t border-dashed border-gray-200 dark:border-gray-700 pt-4">
                                    <div className="flex justify-between mb-2">
                                        <span className="text-sm text-gray-600 dark:text-gray-400">المجموع</span>
                                        <span className="text-sm text-gray-900 dark:text-white">{parseInt(order.total)} <RiyalIcon /></span>
                                    </div>
                                    
                                    {order.discount > 0 && (
                                        <div className="flex justify-between mb-2">
                                            <span className="text-sm text-green-600 dark:text-green-400">الخصم</span>
                                            <span className="text-sm text-green-600 dark:text-green-400">- {parseInt(order.discount)} <RiyalIcon /></span>
                                        </div>
                                    )}
                                    
                                    {order.coupon_code && (
                                        <div className="flex justify-between mb-2">
                                            <span className="text-sm text-gray-600 dark:text-gray-400">كود الخصم</span>
                                            <span className="text-sm text-gray-900 dark:text-white">{order.coupon_code}</span>
                                        </div>
                                    )}
                                    
                                    <div className="flex justify-between font-bold">
                                        <span className="text-base text-gray-900 dark:text-white">الإجمالي</span>
                                        <span className="text-base text-gray-900 dark:text-white">{parseInt(order.final_total)} <RiyalIcon /></span>
                                    </div>
                                </div>

                                {/* أزرار التنقل */}
                                <div className="mt-6 flex justify-center space-x-4 space-x-reverse">
                                    <button
                                        onClick={() => navigate('/')}
                                        className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                                    >
                                        العودة للرئيسية
                                    </button>
                                    <button
                                        onClick={() => navigate('/profile?tab=wallet')}
                                        className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                                    >
                                        مدفوعاتي
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* الجزء المقصوص من الأسفل - شكل مثلثات */}
                    <div className="w-full h-6 bg-gray-100 dark:bg-gray-900 overflow-hidden">
                        <div className="flex w-full justify-between">
                            {[...Array(40)].map((_, i) => (
                                <div key={i} className="w-3 h-6 bg-white dark:bg-gray-800" style={{ clipPath: 'polygon(50% 100%, 0 0, 100% 0)', margin: '0 -1px', boxShadow: '0 -1px 2px rgba(0,0,0,0.1)' }}></div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderConfirmation;
